export { default } from './CarrosEletricosEconomia';
